import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { HiDownload } from "react-icons/hi";
import FileUpload from "../../Constant/fileupload";
import { getModelImportApi } from "../../../services/VehicleService";
const ModelImportModal = ({ visible, onClose, afterSubmit }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState([]);

  const [form, setForm] = useState({
    file: "",
  });
  useEffect(() => {
    if (visible) {
      setError([]);
      handleReset();
    }
  }, [visible]);

  const handleReset = () => {
    setForm({
      file: "",
    });
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("file", form.file);
    setLoading(true);
    getModelImportApi(formData)
      .then((res) => {
        setError([]);
        toast.success("Import Successfully");
        afterSubmit();
      })
      .catch((err) => {
        const errorData = err?.response?.data;
        setError(errorData?.details?.errors || []);
        toast.error(
          errorData?.message || errorData?.error || "Try again later"
        )
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div>
      <Modal show={visible} onHide={onClose} scrollable>
        <Modal.Header closeButton>
          <Modal.Title>Model Import</Modal.Title>
        </Modal.Header>
        <Modal.Body className="scroll-container">
          <div className="row p-1">
            <div className="col-12 mb-1 d-flex justify-content-between align-items-center">
              <label className="form-label m-0 text-dark">
                Upload Excel File
              </label>

              <span
                role="button"
                className="text-primary d-flex align-items-center gap-1"
                onClick={() => {
                  const link = document.createElement("a");
                  link.href = "/sample_excel_file/Model_template.xlsx";
                  link.download = "sample-model-template.xlsx";
                  link.click();
                }}
                style={{ fontSize: "0.875rem", cursor: "pointer" }}
              >
                <HiDownload size={16} />
                Sample Excel
              </span>
            </div>

            <div className="col-12  mt-2 mb-2">
              <FileUpload
                label="Drag & drop File (max size 3MB)"
                accept=".xlsx,.xls,.csv"
                multiple={false}
                value={form.file}
                onChange={(files) => {
                  setForm((prev) => ({ ...prev, file: files }));
                }}
              />
            </div>

            <div className="col-12 mt-2">
              <code className="text-light small d-block">
                <strong>Note:</strong> Upload an Excel file (.xlsx/.xls/.csv)
                with valid asset details.
              </code>
            </div>
          </div>

          <div className="p-2">
            {error.map((msg, index) => (
              <div
                key={index}
                className="rounded-2 text-bg-danger-soft p-2 mb-1"
                style={{ fontSize: "0.8rem" }}
              >
                {msg}
              </div>
            ))}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <span
              className="btn btn-outline-dark"
              disabled={loading}
              onClick={onClose}
            >
              Cancel
            </span>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading || !form.file}
            >
              {loading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Submit
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModelImportModal;
